import { useContext } from "react";

import type { MainClassNameContextValue } from "../../context/sectionTabs/chromeTypes";
import { MainClassNameContext } from "../../context/sectionTabs/MainClassNameContext";

const noop = () => {};

/**
 * No-op fallback when consumed outside a MobileSectionTabsProvider.
 */
const FALLBACK_CONTEXT: MainClassNameContextValue = {
  mainClassName: null,
  setMainClassName: noop,
  clearMainClassName: noop,
};

/**
 * Register/read the class name applied to `MobileShell.Content`'s
 * `<main>` landmark.
 */
export const useMobileMainClassNameContext = () => {
  const context = useContext(MainClassNameContext);
  if (!context && process.env.NODE_ENV === "development") {
    console.warn(
      "useMobileMainClassNameContext: called outside MobileSectionTabsProvider, using noop fallback. " +
        "This is expected for pages on the legacy app shell path.",
    );
  }
  return context ?? FALLBACK_CONTEXT;
};
